import { createAsyncThunk } from "@reduxjs/toolkit";
import { AddJobClosureRejectCommentPayloadType, ApproveAndRejectRegularizePayloadType, GetJobClosureListPayloadType, GetJobClosureRatingListPaylodType, GetRegularizeApprovalPendingListPayloadType, GetScheduledUpcomingInterviewsListPayloadType, GetUnApprovedInvoiceCountPayloadType, SendApprovalStatusPayloadType, SingleApprovalListPayloadType, SingleScheduledUpcomingInterviewsDeatilsPayloadType } from "../../commonTypes/thinksToDoTypes";
import { addJobClosureRejectCommentApi, approveOrRejectRegularizeApi, getJobClosureListApi, getJobClosureRatingListApi, getRegularizeApprovalPendingListApi, getScheduledUpcomingInterviewsApi, getSingleApprovalListActionApi, getUnApprovedInvoiceCountListApi, getWeeklyApprovedUsersInvoiceEntriesCount, sendApprovalStatusActionApi, singleScheduledUpcomingInterviewsApi, updateRecruitmentTrackerActionApi } from "../../apis/thinksToDoApis";
import { AddScheduledUpcomingInterviewsDetailsType } from "./thinksToDoType";


export const getScheduledUpcomingInterviewsList = createAsyncThunk(
    "thinkToDo/getScheduledUpcomingInterviewsList",
    async (data: GetScheduledUpcomingInterviewsListPayloadType) => {
        const response = await getScheduledUpcomingInterviewsApi(data)
        return response.data;
    }
);

export const singleScheduledUpcomingInterviewsDetailsAction = createAsyncThunk(
    "thinkToDo/singleScheduledUpcomingInterviewsDetails",
    async (data: SingleScheduledUpcomingInterviewsDeatilsPayloadType) => { 
        const response=await singleScheduledUpcomingInterviewsApi(data)
        return response.data;
    }
)

//only thinks to do

export const updateRecruitmentTrackerAction = createAsyncThunk(
  "update/recruiterTrackerInThinkgToDo",
  async (data: AddScheduledUpcomingInterviewsDetailsType) => {
    const response = await updateRecruitmentTrackerActionApi(data);
    return response.data;
  }
);

export const sendApprovalStatusAction = createAsyncThunk(
  "thinkToDo/sendApprovalStatus",
  async (data: SendApprovalStatusPayloadType) => {
    const response = await sendApprovalStatusActionApi(data);
    return response.data;
  }
);


export const singleGetApprovalListAction = createAsyncThunk(
  "single/approvalList",
  async (data: SingleApprovalListPayloadType) => {
    const response = await getSingleApprovalListActionApi(data);
    return response.data;
  }
);

export const getJobClosureListAction = createAsyncThunk(
  "jobClosure/get",
  async (data: GetJobClosureListPayloadType) => {
    const response = await getJobClosureListApi(data);
    return response.data;
  }
);
export const getJobClosureRMListAction = createAsyncThunk(
  "jobClosure/getRM",
  async (data: GetJobClosureListPayloadType) => {
    const response = await getJobClosureListApi(data);
    return response.data;
  }
);

export const getJobClosureRatingListAction = createAsyncThunk(
  "jobClosure/getJobClosureRatingList",
  async (data:GetJobClosureRatingListPaylodType) => {
    const response = await getJobClosureRatingListApi(data);
    return response.data;
  }
);

export const addJobClosureRejectCommentAction = createAsyncThunk(
  "jobClosure/addComment",
  async (data: AddJobClosureRejectCommentPayloadType) => {
    const response = await addJobClosureRejectCommentApi(data);
    return response.data;
  }
);

export const getUnApprovedInvoiceCountListAction = createAsyncThunk(
  "unApprovedInvoiceCount/get",
  async (data: GetUnApprovedInvoiceCountPayloadType) => {
    const response = await getUnApprovedInvoiceCountListApi(data);
    return response.data;
  }
);

export const getWeeklyApprovedUsersInvoiceEntriesCountAction = createAsyncThunk(
  "WeeklyApprovedInvoiceCount/get",
  async (data: GetUnApprovedInvoiceCountPayloadType) => {
    const response = await getWeeklyApprovedUsersInvoiceEntriesCount(data);
    return response.data;
  }
);

export const getRegularizeApprovalPendingListAction = createAsyncThunk(
  "regularize/get",
  async (data: GetRegularizeApprovalPendingListPayloadType) => {
    const response = await getRegularizeApprovalPendingListApi(data);
    return response.data;
  }
);

export const approveOrRejectRegularizeAction = createAsyncThunk(
  "regularize/approve",
  async (data: ApproveAndRejectRegularizePayloadType) => {
    const response = await approveOrRejectRegularizeApi(data);
    return response.data;
  }
);